export default "<figure>\n  <div>\n    <img src=\"../../../assets/images/cross-1.3s-347px.svg\">\n  </div>\n</figure>\n"